module.exports = __webpack_public_path__ + "img/money-peak-full-black-logo.e1b2480.png";